import React, { Component, Fragment } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class Datatable extends Component {
  render() {
    const { myData, history } = this.props;
    const rows = myData || [];

    return (
      <Fragment>
        <div className="ln-table-wrap">
          <table className="table ln-table">
            <thead>
              <tr>
                <th scope="col">Customer</th>
                <th scope="col">Amount</th>
                <th scope="col" className="ln-col-action">Inspect</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={3} className="ln-empty">
                    No customers yet.
                  </td>
                </tr>
              ) : (
                rows.map((customer, i) => (
                  <tr key={i}>
                    <td>{String(customer.customer || "").replace(/^undefined-/, "")}</td>
                    <td>
                      <span className="ln-amount-pill">{parseInt(customer.amount)}Tk</span>
                    </td>
                    <td className="ln-col-action">
                      <button
                        type="button"
                        className="ln-icon-btn"
                        onClick={() => {
                          history.push(`/expense/loans-by-customers/${customer.uid}`);
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
